import { LinkWithIcon } from './linkWithIcon';

export default LinkWithIcon;
